<template>
  <div>
    <div class="bsMain" v-for="bookList in bookTable" :key="bookList[0].id">
      <div class="books">
        <transition name="modal">
          <BookModal
            v-if="isSelected"
            :bookId="bookId"
            @close="isSelected = false"
          />
        </transition>
        <ul>
          <li v-for="book in bookList" :key="book.id">
            <button @click="bookClicked(book)">
              <img :src="getImg(book.spine_url)" />
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import BookModal from './BookModal'
import books from '@/assets/book.json'

const baseUrl = 'https://est.d-book.mobi/cloudbookshelf'

export default {
  components: {
    BookModal,
  },
  setup() {
    const bookTable = ref([])
    onMounted(async () => {
      const _books = books

      const width = 19
      let begin = 0
      let end = width
      let _bookTable = []
      while (begin < _books.length) {
        end = Math.min(end, _books.length)
        _bookTable.push(_books.slice(begin, end))

        begin = end + 1
        end = end + width + 1
      }

      bookTable.value = _bookTable
    })

    const getImg = url => baseUrl + '/image' + url

    const isSelected = ref(false)
    const bookId = ref(0)
    const bookClicked = book => {
      isSelected.value = true
      // 数字かどうかのチェックいれる？
      bookId.value = Number(book.id)
    }

    return {
      bookTable,
      isSelected,
      bookId,
      bookClicked,
      getImg,
    }
  },
}
</script>

<style scoped>
.bsMain {
  background: url(../../assets/images/book_shelf_main.png) no-repeat;
  height: 523px;
  position: relative;
}

.books {
  height: 474px;
  width: 1000px;
  position: absolute;
  bottom: 34px;
  left: 66px;
}
.books ul {
  list-style: none;
  font-size: 0;
  position: absolute;
  bottom: 0;
}
.books ul li {
  display: inline-block;
  vertical-align: bottom;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>
